module.exports = __webpack_public_path__ + "static/media/IAQAnalytics4.befc0894.png";